import imageCompression from 'browser-image-compression';

/**
 * Compress an image file to ≤ 2 MB before uploading.
 * Returns the original file untouched if it's already small enough
 * or if it's not an image (e.g. video).
 */
export default async function compressImage(file, maxSizeMB = 2) {
  if (!file) return file;

  // Only compress image types
  if (!file.type.startsWith('image/')) return file;

  // Already under the limit — skip
  if (file.size <= maxSizeMB * 1024 * 1024) return file;

  const options = {
    maxSizeMB,
    maxWidthOrHeight: 2048,
    useWebWorker: true,
    fileType: file.type === 'image/png' ? 'image/png' : 'image/jpeg',
  };

  try {
    const compressed = await imageCompression(file, options);
    // Preserve original filename
    return new File([compressed], file.name, { type: compressed.type });
  } catch {
    // Fallback: return original if compression fails
    return file;
  }
}
